/**
 * HTML sanitization utility to prevent XSS attacks
 * Basic implementation - in production, use a library like DOMPurify
 */

export const sanitizeHTML = (html) => {
  if (!html) return '';
  
  // Create a temporary div element
  const tempDiv = document.createElement('div');
  tempDiv.textContent = html;
  
  // Return sanitized text content
  // For production, use: import DOMPurify from 'dompurify'; return DOMPurify.sanitize(html);
  return tempDiv.innerHTML;
};

/**
 * Sanitize and create safe HTML content
 * This is a basic implementation - for production use DOMPurify
 */
export const createSafeHTML = (html) => {
  if (!html) return '';
  
  // Basic sanitization - remove script tags and dangerous attributes
  const div = document.createElement('div');
  div.textContent = html;
  const sanitized = div.innerHTML
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/on\w+="[^"]*"/gi, '')
    .replace(/javascript:/gi, '');
  
  return sanitized;
};

export default sanitizeHTML;

